import { Component, OnInit, ViewChild } from '@angular/core';

import { TwcPopupComponent } from '@topcon/twc-angular';

import { ToastService } from '@mirage-projects/cw-commons';

import { PermissionsEditorService } from '../permissions-editor.service';
import { PermissionListItem } from '../permissions-list';

/**
 * This component displays the Inherited permissions popup
 */
@Component({
    templateUrl: './inherited-perm-popup.component.html',
    standalone: false,
})
export class InheritedPermPopupComponent implements OnInit {
    permissionsUserName = '';
    inheritedGroupsPermList: PermissionListItem[] = [];
    defaultValues: PermissionListItem[] = [];

    @ViewChild(TwcPopupComponent, { static: false }) inheritedPermPopup!: TwcPopupComponent;

    constructor(
        public permissionsEditorService: PermissionsEditorService,
        private toastService: ToastService
    ) {}

    ngOnInit(): void {
        this.loadUserName();
        this.loadInheritGroups();
        this.loadDefaultValues();
    }

    closePopup(): void {
        this.inheritedPermPopup.onClose();
    }

    private loadUserName(): void {
        if (!this.permissionsEditorService.selectedUser) {
            return;
        }
        this.permissionsUserName = this.permissionsEditorService.getFullName(this.permissionsEditorService.selectedUser);
    }

    private loadInheritGroups(): void {
        const allGroups = this.permissionsEditorService.allGroups;
        const groupPermissionList = this.permissionsEditorService.groupPermissionList;

        const inheritedGroupsPermList = groupPermissionList.filter((groupPerm) => {
            const group = allGroups.find((g) => g.uid === groupPerm.id);
            const isUserBelongingToGroup = group?.users.some((userUid) => userUid === this.permissionsEditorService.selectedUser?.uid);
            return isUserBelongingToGroup;
        });

        this.inheritedGroupsPermList = structuredClone(inheritedGroupsPermList);
    }

    private loadDefaultValues(): void {
        const hasEditPermission = this.inheritedGroupsPermList.some((groupPerm) => {
            const actions = groupPerm.iconsAction;
            return actions.some((action) => action.id === 'edit' && action.status === 'active');
        });

        const hasDeletePermission = this.inheritedGroupsPermList.some((groupPerm) => {
            const actions = groupPerm.iconsAction;
            return actions.some((action) => action.id === 'delete' && action.status === 'active');
        });

        const defaultValue: PermissionListItem = {
            id: 'defaultValue',
            name: 'PERMISSION_DIALOG.DEFAULT_PERMISSIONS',
            iconsAction: [
                {
                    id: 'view',
                    icon: 'eye-show',
                    status: 'active',
                    isDisabled: false,
                },
                {
                    id: 'edit',
                    icon: 'draw',
                    status: hasEditPermission ? 'active' : 'inactive',
                    isDisabled: false,
                },
                {
                    id: 'delete',
                    icon: 'delete',
                    status: hasDeletePermission ? 'active' : 'inactive',
                    isDisabled: false,
                },
            ],
        };
        this.defaultValues = [defaultValue];
    }
}
